import type { FunctionalComponent } from 'vue';

import { IconFamily, ICON_FAMILIES } from './pack';
import type { IconName } from './types';

const resolveIcon = (iconName: IconName): FunctionalComponent | null => {
  const [iconFamily, name] = iconName.split(':');

  if (iconFamily && name) {
    return (
      (ICON_FAMILIES as Record<IconFamily, Record<string, FunctionalComponent>>)[
        iconFamily as IconFamily
      ][name] ?? null
    );
  }

  return null;
};

export { resolveIcon };
